import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TEXT_BASE_CLASS } from '../Text/Text.constants';
import { isWHEnv } from '@/utils/helper';

function Pill({ children, invert, tag = 'pill', style, small, inlineStyle }) {
  return (
    <div
      className={classNames(
        'aaco-pill',
        'flex items-center rounded-3xl border-1 px-[15px] dd-en:px-4 dd-kr:px-4',
        TEXT_BASE_CLASS[tag],
        {
          'border-grey-3 text-white': invert,
          'border-white text-eucalyptus': !invert && !small,
          'border-white bg-white text-eucalyptus': !invert && small,
          'h-8': !small,
          'h-[26px] font-text font-tag text-tag dd-kr:font-text dd-kr:font-small-bold dd-kr:text-small-bold dd-en:font-text dd-en:font-small-bold dd-en:text-small-bold':
            small,
        },
        isWHEnv() ? 'uppercase bg-lichen border-black text-black' : '',
        style
      )}
      // {...(onClick ? (onClick = { onClick }) : null)}
      style={inlineStyle}
    >
      {children}
    </div>
  );
}

Pill.propTypes = {
  children: PropTypes.node,
  invert: PropTypes.bool,
  small: PropTypes.bool,
  tag: PropTypes.string,
  style: PropTypes.string,
  // onClick: PropTypes.func,
  inlineStyle: PropTypes.object,
};


export default Pill;
